import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { SavedItemPayload } from 'models';

import { SAVE_ITEM_COPY } from 'components/buttons/SaveButton';
import { useCurrentUser } from 'hooks/use-current-user';
import { LocalNotificationService } from 'services/LocalNotificationService';
import { SavedItemsService } from 'services/SavedItemsService';

const useSaveItemFromQuery = () => {
    const router = useRouter();
    const user = useCurrentUser();

    const saveItem = async (payload: SavedItemPayload) => {
        const type = payload.item.relationTo;
        const copy =
            type in SAVE_ITEM_COPY ? SAVE_ITEM_COPY[type as keyof typeof SAVE_ITEM_COPY] : SAVE_ITEM_COPY.default;

        await SavedItemsService.create(payload);

        LocalNotificationService.showSuccess({
            message: `${copy.save.message}`,
            actions: [
                {
                    label: 'View all',
                    onClick: SavedItemsService.navigate.overview,
                },
            ],
        });
    };

    useEffect(() => {
        if (!user) return;

        const { action, item, saveType, ...updatedQuery } = router.query;

        if (action !== 'save-item' || !item || !saveType) {
            return;
        }

        const payload = {
            user: user.id,
            item: {
                value: item as string,
                relationTo: saveType as string,
            },
        };

        saveItem(payload);

        const newPath = {
            pathname: router.pathname,
            query: updatedQuery,
        };

        router.replace(newPath, undefined, { shallow: true }).then();
    }, [user?.id, router.query]);
};

export { useSaveItemFromQuery };
